<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6 mt-5 mx-auto">
        <form v-on:submit.prevent="login">
          <h1 class="h3 mb-3 font-weight-normal">Bejelentkezés</h1>
          <b-alert variant="danger" show v-if="errorMessage">
            {{ errorMessage }}
          </b-alert>
          <div class="form-group">
            <label for="email">Email cím</label>
            <input type="email" v-model="email" class="form-control" name="email" placeholder="Enter email" :disabled="twoFactorRequired">
          </div>
          <div class="form-group">
            <label for="password">Jelszó</label>
            <input type="password" v-model="password" class="form-control" name="password" placeholder="Password" :disabled="twoFactorRequired">
          </div>

          <div v-if="twoFactorRequired" class="form-group">
            <label for="twoFactorToken">2FA Kód</label>
            <input type="text" v-model="twoFactorToken" class="form-control" name="twoFactorToken" placeholder="Írd be a 6 számjegyű kódot">
          </div>

          <button type="submit" class="btn btn-lg btn-primary btn-block">Bejelentkezés</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'
import EventBus from './EventBus'

export default {
  data () {
    return {
      email: '',
      password: '',
      errorMessage: '',
      twoFactorRequired: false,
      twoFactorToken: ''
    }
  },

  methods: {
    login () {
      axios.post('https://'+process.env.ROOT_API+'/users/login',
        {
          email: this.email,
          password: this.password,
          twoFactorToken: this.twoFactorToken
        }
      ).then((res) => {
        if (res.data.twoFactorRequired) {
          this.twoFactorRequired = true
          this.errorMessage = ''
          return
        }

        localStorage.setItem('usertoken', res.data)
        let token = localStorage.usertoken
        let decoded = jwtDecode(token)
        localStorage.setItem('userType', decoded.usertype)
        localStorage.setItem('auth', 'loggedin')
        this.email = ''
        this.password = ''
        this.twoFactorToken = ''
        this.twoFactorRequired = false
        this.emitMethod()
        this.errorMessage = ''
        router.push({ name: 'Home' })
      }).catch((err) => {
        console.log(err)
        if (err.response && err.response.data && err.response.data.error) {
          this.errorMessage = err.response.data.error
        } else {
          this.errorMessage = 'Hiba történt a bejelentkezés során.'
        }
      })
    },
    emitMethod () {
      EventBus.$emit('logged-in', 'loggedin')
    }
  },
  mounted () {
    localStorage.removeItem('usertoken')
    localStorage.removeItem('userType')
    localStorage.removeItem('auth')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue